export abstract class ViewModel {
    /**
     * Should return a model of the ViewModel data with unique
     * object identity. I.E. Two calls should not return an identical
     * object or array instance
     */
    public abstract toModel(): any;
}
